import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["Blog"] */ "/app/src/screens/Blog/ui/Blog.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/screens/Main/ui/Main.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["MainSlider"] */ "/app/src/screens/Main/ui/MainSlider/MainSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductCategories"] */ "/app/src/screens/Main/ui/ProductCategories/ProductCategories.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WhyUs"] */ "/app/src/screens/Main/ui/WhyUs/WhyUs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductBlogPosts"] */ "/app/src/screens/Product/ui/ProductBlogPosts/ProductBlogPosts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AlertModal"] */ "/app/src/widgets/AlertModal/ui/AlertModal.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/Feedback/ui/Feedback.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["Form"] */ "/app/src/widgets/Feedback/ui/Form/Form.tsx");
